import { Component } from '@angular/core';
import { EventDto } from '../../../dtos/EventDto';
import { EventService } from '../../../services/event.service';
import { CategoryDto } from '../../../dtos/CategoryDto';

@Component({
  selector: 'app-events',
  standalone: false,
  templateUrl: './app-events.component.html',
  styleUrl: './app-events.component.scss',
  host: {
    class: 'row flex-grow-1'
  }
})
export class EventsComponent {
  events: EventDto[] = [];
  categories: CategoryDto[] = [];
  selectedCategories: CategoryDto[] = [];

  constructor(
    private service: EventService
  ) {
    this.service.getEvents().subscribe((value: any) => { 
      this.events = value;

      [...new Set(this.events.map(event => event.eventName))].forEach(eventName => {
        this.categories.push({
          name: eventName,
          count: this.events.filter(event => event.eventName === eventName).length
        });
      });
    });
  }

  selectCategory(selection: CategoryDto) {
    const index  = this.selectedCategories.findIndex(category => category.name === selection.name);

    if(index !== -1)
      this.selectedCategories.splice(index, 1);
    else
      this.selectedCategories.push(selection);
  }

  containsCategory(selection: CategoryDto) {
    const index  = this.selectedCategories.findIndex(category => category.name === selection.name);

    return index !== -1;
  }

    containsEvent(event: EventDto) {
    const index  = this.selectedCategories.findIndex(category => category.name === event.eventName);

    return index !== -1;
  }

  getDate(event: EventDto): string {
    return new Date(event.eventDate).toLocaleDateString()
  }

  getTime(event: EventDto): string {
    return new Date(event.eventDate).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  }

  empty(): boolean {
    return !this.events.some((event) => !event.unlisted);
  }
}
